module.exports = __webpack_public_path__ + "static/media/student-snapshort1-matching.f8b97bb7.png";